/* Quies · selector de packs propio (sustituye a la app de bundles) · 3-nov-2026
   Misma apariencia que el widget antiguo (clases qpk__*), pero SIN app y SIN descuentos:
   cada linea del carrito es una variante con SU precio (productos qpk-a-* / qpk-b-*).
   Config en window.QPK (la pinta snippets/quies-packs.liquid). Revertir = volver al bloque de app. */
(function () {
  'use strict';
  var C = window.QPK; if (!C) return;
  var root = document.querySelector('[data-qpk-root]'); if (!root || root.dataset.ready) return;
  var P = C.prices[C.currency] || C.prices.USD, V = C.variants, CUR = C.prices[C.currency] ? C.currency : 'USD';

  function money(c) { // cents -> "$96" (USD) | "$ 1,764" (MXN), sin decimales
    var n = Math.round(c / 100), s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return CUR === 'MXN' ? '$ ' + s : '$' + s;
  }
  var S = { bar: 0, noches: '100', tira: true, uid: Math.random().toString(36).slice(2, 8) };
  var IMG = C.img;

  function pr(group, key) { return P[group][key]; }               // [precio, tachado] en centimos
  function linesFor(i, forTotals) {
    var b = C.bars[i], L = [];
    if (b.pair) {
      L.push({ id: V.disp.par, q: 2, g: 'disp', k: 'par' });
      L.push({ id: V.parches['100'], q: 1, g: 'parches', k: '100' });
      L.push({ id: V.tira.x2, q: 1, g: 'tira', k: 'x2' });
    } else {
      L.push({ id: V.disp.pro, q: 1, g: 'disp', k: 'pro' });
      L.push({ id: V.parches[S.noches], q: 1, g: 'parches', k: S.noches });
      if (S.tira) L.push({ id: V.tira.one, q: 1, g: 'tira', k: 'one' });
    }
    return L;
  }
  function sums(i) {
    var p = 0, f = 0; linesFor(i).forEach(function (l) { var x = pr(l.g, l.k); p += x[0] * l.q; f += x[1] * l.q; });
    return { p: p, f: f };
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function prodRow(img, name, price, full, qty, link, select) {
    return '<div class="qpk__bundle-products__product">' +
      '<' + (link ? 'a target="_blank" href="' + link + '"' : 'div') + ' class="qpk__bundle-products__link"><img alt="" class="qpk__bundle-products__image" height="50" width="50" loading="lazy" src="' + img + '"></' + (link ? 'a' : 'div') + '>' +
      '<' + (link ? 'a target="_blank" href="' + link + '"' : 'div') + ' class="qpk__bundle-products__link"><div class="qpk__bundle-products__title">' + (qty > 1 ? '<span class="qpk__bundle-products__quantity">' + qty + 'x</span> ' : '') + '<span>' + name + '</span></div></' + (link ? 'a' : 'div') + '>' +
      '<div class="qpk__bundle-products__pricing"><span class="qpk__bundle-products__price">' + money(price) + '</span> <span class="qpk__bundle-products__full-price">' + money(full) + '</span> </div>' + (select || '') + '</div>';
  }
  var DIV = '<div class="qpk__bundle-products__divider"><div class="qpk__bundle-products__divider-line">​</div> <div class="qpk__bundle-products__divider-icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="currentColor"></circle><path fill="#fff" d="M5 9h10v2H5z"></path><path fill="#fff" d="M11 5v10H9V5z"></path></svg></div> <div class="qpk__bundle-products__divider-line">​</div></div>';
  var CHECK = '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true"><path d="M12.334 1 5 8.333 1.667 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function barHtml(i) {
    var b = C.bars[i], sel = S.bar === i, s = sums(i), id = 'qpk-' + S.uid + '-' + i;
    var dev = P.disp[b.pair ? 'par' : 'pro'], pat = P.parches[b.pair ? '100' : S.noches], tir = P.tira[b.pair ? 'x2' : 'one'];
    var devQ = b.pair ? 2 : 1;
    var select = '';
    if (!b.pair) {
      select = '<div class="qpk__bar-variant"><div class="qpk__bar-variant__content"><div class="qpk__bar-variant-main"><div class="qpk__bar-variant-selects"><select class="qpk__bar-variant-select qpk-option" aria-label="Cantidad" data-qpk-noches>' +
        ['100', '200', '300'].map(function (n) { return '<option value="' + n + '"' + (n === S.noches ? ' selected' : '') + '>' + n + ' noches</option>'; }).join('') + '</select></div></div></div></div>';
    }
    var linkPat = '/products/quies-pro-parche-adhesivo?variant=' + C.orig.parches[b.pair ? '100' : S.noches];
    var up = '<div class="qpk__upsell" data-qpk-up><div class="qpk__upsell__main">' +
      (b.pair ? '<div class="qpk__upsell__link"><img alt="" class="qpk__upsell__image" loading="lazy" src="' + IMG.tira + '" height="30"></div>' :
        '<span role="button" tabindex="0" data-qpk-check class="qpk__upsell__checkbox' + (S.tira ? ' qpk__upsell__checkbox--selected' : '') + '">' + CHECK + '</span> <a target="_blank" href="/products/quies-parche-con-tira-elastica?variant=' + C.orig.tira + '" class="qpk__upsell__link"><img alt="" class="qpk__upsell__image" loading="lazy" src="' + IMG.tira + '" height="30"></a>') +
      '<div class="qpk__upsell__content"><span role="button" tabindex="0" data-qpk-check class="qpk__upsell__text">' + esc(b.upsellText) + '</span></div></div>' +
      '<div class="qpk__upsell__pricing"><div class="qpk__upsell__price">' + money(tir[0]) + '</div> <div class="qpk__upsell__full-price">' + money(tir[1]) + '</div></div></div>';
    var withTira = b.pair || S.tira;
    var total = s.p, full = s.f;
    return '<div class="qpk__bar' + (sel ? ' qpk__bar--selected' : '') + '" data-qpk-bar="' + i + '">' +
      '<input type="radio" name="qpk-deal-' + S.uid + '" value="' + i + '" id="' + id + '" class="needsclick"' + (sel ? ' checked' : '') + '>' +
      '<label for="' + id + '" class="qpk__bar-container">' +
      '<div class="qpk__bar-most-popular qpk__bar-most-popular--simple"><div class="qpk__bar-most-popular__content">' + esc(b.badge) + '</div></div>' +
      '<div class="qpk__bar-wrapper"><div role="button" tabindex="0" class="qpk__bar-main"><div class="qpk__bar-radio"></div>' +
      '<div class="qpk__bar-content"><div class="qpk__bar-content-left"><div class="qpk__bar-first-line"><span class="qpk__bar-title">' + esc(b.title) + '</span> <span class="qpk__bar-label">' + esc(b.label) + '</span></div>' +
      '<div class="qpk__bar-subtitle" data-qpk-save>¡Ahorra ' + money(full - total) + '!</div></div>' +
      '<div class="qpk__bar-pricing"><div class="qpk__bar-price" data-a11y-label="Precio:">' + money(total) + ' </div> <div class="qpk__bar-full-price" data-a11y-label="Precio original:">' + money(full) + '</div></div></div></div>' +
      '<div class="qpk__bundle-products">' +
        prodRow(IMG.disp, 'Quies', dev[0] * devQ, dev[1] * devQ, devQ, null) + DIV +
        prodRow(IMG.parches, 'Parches Adhesivos', pat[0], pat[1], 1, linkPat, sel ? select : '') +
      '</div></div>' + up + '</label></div>';
  }
  function timerHtml() { return '<div class="qpk__timer" role="timer"><div class="qpk__timer-title">LA OFERTA ACABA EN <span class="qpk__timer-value" translate="no" data-qpk-timer> 00:00:00 </span></div></div>'; }
  function render() {
    root.innerHTML = '<div class="qpk"><div class="qpk__block qpk__block--loaded">' + timerHtml() + '<div class="qpk__bars">' + C.bars.map(function (b, i) { return barHtml(i); }).join('') + '</div></div></div>';
    tick(); publish();
  }
  function tick() {
    var el = root.querySelector('[data-qpk-timer]'); if (!el) return;
    var n = new Date(), e = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0, 0), d = Math.max(0, Math.floor((e - n) / 1000));
    function z(x) { return (x < 10 ? '0' : '') + x; }
    el.textContent = ' ' + z(Math.floor(d / 3600)) + ':' + z(Math.floor(d % 3600 / 60)) + ':' + z(d % 60) + ' ';
  }
  setInterval(tick, 1000);

  function publish() { // el resto del tema (barra fija, lotes, regalos) lee window.QPK_STATE y/o el DOM
    var s = sums(S.bar);
    window.QPK_STATE = { bar: S.bar, price: s.p, full: s.f, lines: linesFor(S.bar), currency: CUR };
    document.dispatchEvent(new CustomEvent('qpk:change', { detail: window.QPK_STATE }));
  }
  function update() { render(); }

  root.addEventListener('click', function (e) {
    var t = e.target, bar = t.closest && t.closest('[data-qpk-bar]');
    if (t.closest && t.closest('a')) return;                          // enlaces a la ficha: normal
    if (t.tagName === 'SELECT' || t.tagName === 'OPTION') return;
    if (!bar) return;
    e.preventDefault();
    var i = +bar.dataset.qpkBar;
    if (t.closest('[data-qpk-check]') && !C.bars[i].pair) { S.bar = i; S.tira = !S.tira; update(); return; }
    if (S.bar !== i) { S.bar = i; update(); }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-qpk-noches]')) { S.noches = e.target.value; update(); }
  });
  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[role=button]')) { e.preventDefault(); e.target.click(); }
  });

  /* ---- compra: el boton de la pagina (y por tanto la barra fija) lleva el pack elegido al carrito ---- */
  var busy = false;
  function addPack(btn) {
    if (busy) return; busy = true; if (btn) btn.setAttribute('disabled', 'disabled');
    var b = C.bars[S.bar], ls = linesFor(S.bar), items = ls.map(function (l) {
      return { id: l.id, quantity: l.q, properties: { '_pack': b.title, '_qpk': C.deal } };
    });
    var esperado = ls.reduce(function (a, l) { return a + pr(l.g, l.k)[0] * l.q; }, 0);
    function fin(msg) { busy = false; if (btn) btn.removeAttribute('disabled'); if (msg) alert(msg); }
    var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    // 1) quitar SOLO las lineas de pack (_qpk) que ya hubiera (volver del checkout, cambiar de pack): se reemplazan, no se suman.
    //    Atributos/nota del carrito y lineas ajenas no se tocan.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var upd = {}, n = 0;
        cart.items.forEach(function (i) { if (i.properties && i.properties._qpk) { upd[i.key] = 0; n++; } });
        if (!n) return null;
        return fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: upd }) })
          .then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r; });
      })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var mine = cart.items.filter(function (i) { return i.properties && i.properties._qpk; });
        var got = mine.reduce(function (a, i) { return a + i.final_line_price; }, 0);
        // red de seguridad: nadie paga mas de lo que le ensenamos
        if (got > esperado + 2 && cart.currency === CUR) {
          console.error('[qpk] carrito ' + got + ' vs esperado ' + esperado);
          return fetch('/cart/clear.js', { method: 'POST' }).then(function () { fin('No hemos podido preparar el pack. Recarga la página e inténtalo de nuevo.'); });
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) { console.error('[qpk] ' + err.message); fin('No hemos podido añadir el pack. Recarga la página e inténtalo de nuevo.'); });
  }
  window.QPK_ADD = addPack;
  document.addEventListener('click', function (e) {          // captura: gana a los manejadores del tema
    var btn = e.target.closest && e.target.closest('.shop-add-to-cart-button, #StickyATCButton, #stickyAddToCartBtnMobile');
    if (!btn) return;
    if (!document.querySelector('[data-qpk-root] .qpk')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addPack(btn.classList.contains('shop-add-to-cart-button') ? btn : null);
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.querySelector && e.target.querySelector('.shop-add-to-cart-button') && document.querySelector('[data-qpk-root] .qpk')) { e.preventDefault(); e.stopImmediatePropagation(); addPack(null); }
  }, true);

  root.dataset.ready = '1'; render();
})();
